import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import servicioHttp from '../servicios/ServicioHttp';
import servicioFormatos from '../servicios/ServicioFormatos';
import servicioArchivos from '../servicios/ServicioArchivos';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import { InputText } from 'primereact/inputtext';
import { CALENDARIO_ES_MX } from '../servicios/ServicioConstantes';

export class CfdiLayoutTelepeaje extends Component {

    constructor() {
        super();
        this.state = {
            inicio: 0,
            paginacion: {
                registrosPorPagina: 20,
                join: { "ttCfdi": "alias_ttCfdi" },
                restriccionesDinamicas: [
                ]
            },
            restricionPricipal: {
                tipoRestriccion: "isNotNull",
                nombrePropiedad: "alias_ttCfdi.uuid"
            },
            restricciones: {}
        };
        //this.obtenerCfdi();
    }

    agregarRestriccionPrincipal = () => {
        let { paginacion, restricionPricipal } = this.state;
        var item = paginacion.restriccionesDinamicas.find(item => item.tipoRestriccion === "isNotNull");
        if (servicioAsignacionValoresObjetos.esObjetoVacio(item)) {
            paginacion.restriccionesDinamicas.push(restricionPricipal);
        }
    }

    obtenerCfdi = () => {
        this.agregarRestriccionPrincipal();
        let { paginacion } = this.state;
        servicioHttp.consumirPostHttp('/detalle_layout_telepeaje/consultar.json', paginacion).then(response => {
            this.setState({
                paginacion: response.data.objeto
            });
        }).catch(error => {

        });
    }

    cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerCfdi();
    }

    templateColumnaFecha = (rowData, column) => {
        return servicioFormatos.formatearFecha(rowData.fechaCertificacion);
    }

    templateColumnaTotal = (rowData, column) => {
        return servicioFormatos.formatearModena(rowData.total);
    }

    templateXml = (rowData, column) => {
        return <Button icon="pi-md-file-download" className="p-button-success" onClick={() => this.descargaArchivo(rowData.id, 'xml')} />;
    }

    templatePdf = (rowData, column) => {
        return <Button icon="pi-md-file-download" className="p-button-danger" onClick={() => this.descargaArchivo(rowData.id, 'pdf')} />;
    }

    descargaArchivo = (id, tipo) => {
        servicioArchivos.descargaArchivo('/detalle_layout_telepeaje/descarga_documento.json?id=' + id + '&tipo=' + tipo);
    }

    asignarValoresObjeto = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
    }

    buscar = (aplicarBusqueda) => {
        let { paginacion, restricciones } = this.state;
        //let clonPaginacion=JSON.parse(JSON.stringify(paginacion));
        if (!servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.serie)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_ttCfdi.serie",
                valorPropiedad: restricciones.serie
            });
        }
        if (!servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.folio)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_ttCfdi.folio",
                valorPropiedad: restricciones.folio
            });
        }
        if (!servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.fechaInicio) && !servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.fechaFin)) {
            let fechaIncial = servicioFormatos.formatearFechaString(restricciones.fechaInicio);
            let fechaFinal = servicioFormatos.formatearFechaString(restricciones.fechaFin).replace('00:00:00','23:59:59');
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "between",
                nombrePropiedad: "alias_ttCfdi.fechaCertificacion",
                valorPropiedad: null,
                fechaIncialBetween: fechaIncial,
                fechaFinalBetween: fechaFinal
            });
        }
        if (!servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.idCliente)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "idCliente",
                valorPropiedad: restricciones.idCliente
            });
        }
        if (!servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.idCuenta)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "idCuenta",
                valorPropiedad: restricciones.idCuenta
            });
        }

        if (!servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.periodo)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "periodo",
                valorPropiedad: restricciones.periodo
            });
        }
        if (!servicioAsignacionValoresObjetos.esObjetoVacio()) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "periodo",
                valorPropiedad: restricciones.periodo
            });
        }
        if (!servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.uuid)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_ttCfdi.uuid",
                valorPropiedad: restricciones.uuid
            });
        }
        if (!servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.total)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_ttCfdi.total",
                valorPropiedad: restricciones.total,
                claseAtributoEspecial: "java.math.BigDecimal"
            });
        }
        if (!servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.subtotal)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_ttCfdi.subtotal",
                valorPropiedad: restricciones.subtotal,
                claseAtributoEspecial: "java.math.BigDecimal"
            });
        }
        if (!servicioAsignacionValoresObjetos.esObjetoVacio(restricciones.descuento)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_ttCfdi.descuento",
                valorPropiedad: restricciones.descuento,
                claseAtributoEspecial: "java.math.BigDecimal"
            });
        }
        if (!servicioAsignacionValoresObjetos.esObjetoVacio(aplicarBusqueda)) {
            this.obtenerCfdi();
        }

    }

    descargaZip = () => {
        this.agregarRestriccionPrincipal();
        this.buscar();
        let { paginacion } = this.state;
        paginacion.numeroPagina=0;
        servicioArchivos.descargaArchivo('/detalle_layout_telepeaje/descargar_zip.json', paginacion, this);
        this.obtenerCfdi();
    }

    descargaExcelInformatica = () => {
        this.agregarRestriccionPrincipal();
        this.buscar();
        let { paginacion } = this.state;
        paginacion.numeroPagina=0;
        servicioArchivos.descargaArchivo('/detalle_layout_telepeaje/informatica/descargar_excel.json', paginacion, this);
        this.obtenerCfdi();
    }

    descargaExcelContabilidad = () => {
        this.agregarRestriccionPrincipal();
        this.buscar();
        let { paginacion } = this.state;
        paginacion.numeroPagina=0;
        servicioArchivos.descargaArchivo('/detalle_layout_telepeaje/contabilidad/descargar_excel.json', paginacion, this);
        this.obtenerCfdi();
    }


    render() {

        let { paginacion, inicio, restricciones } = this.state;

        return (
            <div className="p-fluid">
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <div className="p-grid">
                                <div className="p-col-8"><h1>CFDI Layout Telepeaje</h1></div>                                
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                <div className="p-col-8"><h4 style={{marginTop:'0'}}>Es esta sección usted puede descargar sus facturas de telepeaje:</h4></div>
                    <div className="p-grid" style={{padding:'30px 30px 10px 30px'}}>
                        <div className="p-col-12 p-md-2">
                            <label className="title__input-label">Serie:</label>
                            <InputText id="restricciones.serie" name="restricciones.serie" value={restricciones.serie || ''} onChange={this.asignarValoresObjeto}></InputText>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label className="title__input-label">Folio:</label>
                            <InputText id="restricciones.folio" name="restricciones.folio" value={restricciones.folio || ''} onChange={this.asignarValoresObjeto}></InputText>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label className="title__input-label">Fecha Inicio:</label>
                            <Calendar id="restricciones.fechaInicio" name="restricciones.fechaInicio" value={restricciones.fechaInicio || ''} onChange={this.asignarValoresObjeto} locale={CALENDARIO_ES_MX}></Calendar>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label className="title__input-label">Fecha Fin:</label>
                            <Calendar id="restricciones.fechaFin" name="restricciones.fechaFin" value={restricciones.fechaFin || ''} onChange={this.asignarValoresObjeto} locale={CALENDARIO_ES_MX}></Calendar>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label className="title__input-label">ID Cliente:</label>
                            <InputText id="restricciones.idCliente" name="restricciones.idCliente" value={restricciones.idCliente || ''} onChange={this.asignarValoresObjeto}></InputText>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label className="title__input-label">ID Cuenta:</label>
                            <InputText id="restricciones.idCuenta" name="restricciones.idCuenta" value={restricciones.idCuenta || ''} onChange={this.asignarValoresObjeto}></InputText>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label className="title__input-label">Periodo:</label>
                            <InputText id="restricciones.periodo" name="restricciones.periodo" value={restricciones.periodo || ''} onChange={this.asignarValoresObjeto}></InputText>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label className="title__input-label">UUID:</label>
                            <InputText id="restricciones.uuid" name="restricciones.uuid" value={restricciones.uuid || ''} onChange={this.asignarValoresObjeto}></InputText>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label className="title__input-label">Total:</label>
                            <InputText id="restricciones.total" name="restricciones.total" value={restricciones.total || ''} onChange={this.asignarValoresObjeto}></InputText>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label className="title__input-label">Subtotal:</label>
                            <InputText id="restricciones.subtotal" name="restricciones.subtotal" value={restricciones.subtotal || ''} onChange={this.asignarValoresObjeto}></InputText>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label className="title__input-label">Descuento:</label>
                            <InputText id="restricciones.descuento" name="restricciones.descuento" value={restricciones.descuento || ''} onChange={this.asignarValoresObjeto}></InputText>
                        </div>
                        <div className="p-col-12 p-md-12 title__btn-search">
                            <Button label="Buscar" icon="pi-md-search" className="p-button-success" onClick={() => { this.buscar(true) }} />
                        </div>        
                    </div>
                    
                </div>

                {(null != paginacion.datos && paginacion.datos.length > 0) ? <div className="card">
                    <div className="p-grid" style={{display:'flex', justifyContent:'space-evenly', padding:'20px 0'}}>
                        <div className="p-col-4">
                            <Button label="Descargar Zip" icon="pi-md-file-download" className="indigo-btn flat-btn" onClick={() => { this.descargaZip() }} />
                        </div>
                        <div className="p-col-4">
                            <Button label="Exportar Excel Informatica" icon="pi-md-file-download" className="indigo-btn flat-btn" onClick={() => { this.descargaExcelInformatica() }} />
                        </div>
                        <div className="p-col-4">
                            <Button label="Exportar Excel Contabilidad" icon="pi-md-file-download" className="indigo-btn flat-btn" onClick={() => { this.descargaExcelContabilidad() }} />
                        </div>
                    </div>
                </div> : ""}

                <div className="p-grid" style={{justifyContent:'space-between'}}>
                    <div className="p-col-12">
                        <div className="card">
                            <DataTable value={paginacion.datos} header="CFDI LAYOUT" responsive={true} resizableColumns={true}>
                                <Column body={this.templateXml} header="XML" style={{textAlign:'center'}} />
                                <Column body={this.templatePdf} header="PDF" style={{textAlign:'center'}}/>
                                <Column field="tipoComprobante" header="Tipo" autoLayout={true} resizableColumns={true} style={{textAlign:'center'}}/>
                                <Column field="serie" header="Serie" autoLayout={true} resizableColumns={true} style={{textAlign:'center'}}/>
                                <Column field="folio" header="Folio" autoLayout={true} resizableColumns={true} style={{textAlign:'center'}}/>
                                <Column body={this.templateColumnaFecha} header="Fecha" autoLayout={true} resizableColumns={true} style={{textAlign:'center'}}/>
                                <Column field="nombre" header="Nombre Cliente" autoLayout={true} resizableColumns={true} style={{textAlign:'center'}}/>
                                <Column body={this.templateColumnaTotal} header="Total" autoLayout={true} resizableColumns={true} style={{textAlign:'center'}}/>
                                <Column field="uuid" header="UUID" autoLayout={true} resizableColumns={true} style={{textAlign:'center'}}/>
                                <Column field="idCliente" header="ID Cliente" autoLayout={true} resizableColumns={true} style={{textAlign:'center'}}/>
                                <Column field="idCuenta" header="ID Cuenta" autoLayout={true} resizableColumns={true} style={{textAlign:'center'}}/>
                                <Column field="periodo" header="Periodo" autoLayout={true} resizableColumns={true} style={{textAlign:'center'}}/>
                            </DataTable>
                            <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}